export default __webpack_public_path__ + "static/media/brand-logo-raya.e611070e.webp";